import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Cached content settings so every consumer doesn't re-fetch. Cleared on
// page reload — no live invalidation needed since the Admin CMS save flow
// tells the operator "changes appear on next page load".
let _cached = null;
let _pending = null;

// Fetch once, share result — small hook so Home / Contact / Layout can all
// override hard-coded defaults with whatever the admin last saved.
export function useContentSettings() {
  const [content, setContent] = useState(_cached);
  useEffect(() => {
    if (_cached) return;
    if (!_pending) {
      _pending = axios.get(`${API}/settings/content`)
        .then((r) => { _cached = r.data || {}; return _cached; })
        .catch(() => { _cached = {}; return _cached; });
    }
    _pending.then((v) => setContent(v));
  }, []);
  return content || {};
}
